import React from 'react';
import TimesheetManagement from './TimesheetManagement';

const TimesheetMain: React.FC = () => {
  return (
    <div>
      <TimesheetManagement />
    </div>
  );
};

export default TimesheetMain;
